import { Button, IconButton } from "@material-ui/core";
import React from "react";
import MenuIcon from "@material-ui/icons/Menu";
import { useDispatch, useSelector } from "react-redux";
import ProfileMenu from "../profile-menu/profile-menu";
import styles from "./styles.less";
import ExirioStyles from "../../utils/exirioStyles";

export function MobileHomeAppBar({ onHome }) {
	const dispatch = useDispatch();

	const toggleSideBar = () => {
		dispatch({ type: "TOGGLE_SIDEBAR_COLLAPSED" });
	};
	const onRegisterNowClick = () => {
		dispatch({ type: 'GOTO_CONFIRM_GUEST_HOLDINGS_DELETE', payload: true })
	}
	const { isGuestUser, showGuestBtns } = useSelector(state => ({
		isGuestUser: state.guest.isGuestUser,
		showGuestBtns: state.guest.showGuestBtns,
	}))

	return (
		<>
			<div className={styles.headActionWrapper}>
				<IconButton
					edge="start"
					color="inherit"
					aria-label="open drawer"
					onClick={toggleSideBar}
				>
					<MenuIcon />
				</IconButton>
				<div className={styles.logoWrapper}>
					<img
						alt="logo"
						style={{ width: "2em" }}
						onClick={onHome}
						className={styles.logo}
						src={"/logo.svg"}
					/>
				</div>
			</div>
			{isGuestUser ? (
				<Button
					onClick={onRegisterNowClick}
					disabled={!showGuestBtns}
					variant="contained"
					style={{
						borderRadius: 20,
						backgroundColor: ExirioStyles.mintMarketing,
						color: ExirioStyles.background,
						opacity: !showGuestBtns ? 0.5 : 1,
						textTransform: 'none',
						letterSpacing:0.5,
					}}
				>
					{'Register Now'}
				</Button>
			) :
				<div className={styles.headActionWrapper}>
					<ProfileMenu />
				</div>
			}

		</>
	);
}
